/**
 * 实体交互事件类型常量。
 *
 * 设计说明：
 * 1. 事件标识属于选择协议，不依赖 `EntitySelectionManager` 的具体实现；
 * 2. 选择处理器与管理器共同依赖本协议，避免基类为了读取事件标识反向加载管理器；
 * 3. 使用只读常量对象表达有限选项，避免枚举生成额外运行时代码。
 */
export const EntityInteractionEventType = {
    /** 鼠标移入实体事件。 */
    EntityHoverEnter: 'entity-hover-enter',
    /** 鼠标移出实体事件。 */
    EntityHoverLeave: 'entity-hover-leave',
    /** 实体选中事件。 */
    EntitySelected: 'entity-selected',
    /** 特征面选中事件。 */
    FeatureFaceSelected: 'feature-face-selected',
    /** 特征线选中事件。 */
    FeatureLineSelected: 'feature-line-selected',
    /** 特征点选中事件。 */
    FeaturePointSelected: 'feature-point-selected',
    /** 实体框选事件。 */
    EntityBoxSelected: 'entity-box-selected',
    /** 点选中事件。 */
    PointSelected: 'point-selected',
    /** 线选中事件。 */
    LineSelected: 'line-selected',
    /** 圆选中事件。 */
    CircleSelected: 'circle-selected',
    /** 圆弧选中事件。 */
    ArcSelected: 'arc-selected',
    /** 椭圆选中事件。 */
    EllipseSelected: 'ellipse-selected',
    /** 样条曲线选中事件。 */
    SplineSelected: 'spline-selected',
    /** 样式样条曲线选中事件。 */
    StyleSplineSelected: 'style-spline-selected',
    /** 槽口选中事件。 */
    SlotSelected: 'slot-selected',
    /** 选择清空事件。 */
    SelectionCleared: 'selection-cleared',
    /** 选择结算事件。 */
    SelectionUpdated: 'selection-updated',
    /** 多实体框选事件（用于几何关系面板）。 */
    MultipleEntitiesBoxSelected: 'multiple-entities-box-selected',
} as const;
